
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import PartResultItem from './PartResultItem.vue';
import { getPartPartsList } from '@/api/apis';
import Banner from '@/components/banner/Banner.vue';

export default defineComponent({
  name: 'PartResult',
  data() {
    return {
      loading: false,
      parts: [],
      pageNo: 1,
      pageSize: 8,
      pageSizeOptions: ['8', '16', '24'],
      current: 1,
      total: 0,
      hasResult: true,
      hasModel: false,
      // query
      modelNum: '',
      model: '',
      partName: '',
      vehicleId: ''
    };
  },
  components: {
    PartResultItem,
    Banner
  },
  created() {
    const route = useRoute();

    const query = route.query || {};

    this.hasModel = Number(query.isNo) === 0;

    this.model = query.model as string;

    this.hasResult = Number(query.hasResult) === 1;

    this.vehicleId = query.vehicleId as string;
    if (this.hasModel) {
      if (this.hasResult) {
        this.partName = query.partName as string;

        this.loadData();
      }
    } else {
      if (this.hasResult) {
        this.modelNum = query.modelNum as string;

        this.loadData();
      }
    }
  },
  methods: {
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;

      const params: any = {
        modelNum: this.modelNum,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        partName: this.partName
      };

      // if (this.hasModel) {
      //   params.vehicleId = +this.vehicleId;
      // }
      params.vehicleId = +this.vehicleId || undefined;

      const res = await getPartPartsList(params);

      if (res.success) {
        const data = res.result || {};

        this.parts = data.records || [];

        this.total = data.total;

        this.hasResult = this.total > 0;
      }

      this.loading = false;
    }
  }
});
